// extracted by mini-css-extract-plugin
export var actionsRow = "_v-a";
export var actionsRowEnd = "_v-b";
export var askRedoBlackBtn = "_v-d";
export var askRedoBlackBtnIcon = "_v-e";
export var exitModalActionBtn = "_v-c";
export var exitModalRoot = "_v-0";
export var followUpInput = "_v-9";
export var modalContentBody = "_v-7";
export var modalHeaderImage = "_v-2";
export var modalImageLabel = "_v-4";
export var modalImageOverlay = "_v-3";
export var modalImageSubheading = "_v-6";
export var modalImageTitle = "_v-5";
export var modalImageWrapper = "_v-1";
export var reasonCard = "_v-f";
export var reasonCardSelected = "_v-g";
export var reasonIcon = "_v-j";
export var reasonIconWrap = "_v-i";
export var reasonIndicator = "_v-l";
export var reasonIndicatorDot = "_v-n";
export var reasonIndicatorSelected = "_v-m";
export var reasonLabel = "_v-h";
export var reasonList = "_v-8";
export var reasonTitle = "_v-k";